/* eslint-disable
    consistent-return,
    no-loop-func,
    no-shadow,
    no-unused-vars,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import $ from 'jquery';
import simplify from 'simplify-js';
import _ from 'underscore';

import {assert} from 'Asserts';
import {ALIGNMENT_SCROLLING_PERF_INTERVAL} from 'constants/AlignmentConstants';
import Component from 'molbio/maps/linear/Component';
import GapSequenceWrapper from 'analyses/alignment/GapSequenceWrapper';
import * as vo from 'components/VisibilityOptions';
import * as Perf from 'performance/Perf';
import addTestAttrsToD3Selection from 'test/lib/cypress/addTestAttrsToD3Selection';
import * as logging from 'util/Logging';
import {debounce} from 'ts-debounce';

class TraceView extends Component {
  static initClass() {
    this.prototype.className = 'trace';
    this.prototype.setting = vo.TRACE.name;
  }

  initialize(options) {
    super.initialize(options);
    this.performanceId = Perf.start(
      'drawAlignmentTrace',
      {enabled: false},
      {
        interval: ALIGNMENT_SCROLLING_PERF_INTERVAL,
        aggregations: [Perf.Aggregation.MEDIAN, Perf.Aggregation.MAX],
      },
      {}
    );
    this.data = options.data;
    this.tabstate = options.tabstate;
    this.slice = options.slice;
    this.range = options.range;
    this.layout = this.model.get('layout').Trace;
    this.sequence = this.model.get('sequence');
    return assert(
      this.sequence instanceof GapSequenceWrapper,
      'Trace view must take a gap sequence wrapper!'
    );
  }

  qualityOption() {
    return this.model.get('visibilityOptions').getOption(vo.TRACE_QUALITY.name);
  }

  showHandler(state, value) {
    super.showHandler(state, value);
    return this.model.trigger('traceToggle');
  }

  _getIndexToBases(colorData, start, end, xTransform, yTransform) {
    let p;
    const path = [];
    let didWarn = false;
    for (
      var base = start, end1 = end, asc = start <= end1;
      asc ? base < end1 : base > end1;
      asc ? base++ : base--
    ) {
      var points = colorData[base];
      if (points == null) {
        // Sometimes after a realignment, we rerender the new sequence before the slice end is updated,
        // likely due to a backbone listeners firing. The hypothesis is that this warning only happens
        // when sliceEnd > sequenceLength (they should always be equal for alignments right now),
        // so we only warn if that sliceEnd <= sequenceLength. Ref T1356.
        if (!didWarn && this.slice.end() <= this.sequence.length()) {
          didWarn = true;
          // TODO(T1356) Unexpected, but we warn with extra data and fall back to empty array.
          // Use soaked accessors just to be defensive, in case we're in a weird state.
          logging.warn('T1356: colorData[base] is undefined, falling back to []', {
            extra: {
              base,
              start,
              end,
              colorDataLength: colorData.length,
              sliceStart: this.slice != null ? this.slice.start() : undefined,
              sliceEnd: this.slice != null ? this.slice.end() : undefined,
              sequenceLength: this.sequence != null ? this.sequence.length() : undefined,
            },
          });
        }
        points = [];
      }
      if (points.length === 0) {
        path.push(null);
      } else {
        const dicts = points.map((point, i) => ({
          x: xTransform(base + i / points.length),
          y: yTransform(point),
        }));
        var simplified = simplify(dicts, 1, false);
        path.push(...simplified.map((p) => [p.x, p.y]));
      }
    }
    return path;
  }

  _getDataString(points, xTransform, yTransform) {
    const n = points.length;
    const path = [];
    let type = 'M';
    let index = 0;
    while (index < n) {
      if (points[index]) {
        path.push(type, xTransform(points[index][0]), ',', yTransform(points[index][1]), ' ');
        type = 'L';
      } else {
        type = 'M';
      }
      index++;
    }
    return path.join('');
  }

  drawHoverBoxes() {
    Perf.markStart(this.performanceId);

    // From the slice we determine where the boxes should go.
    const start = Math.floor(this.range.start());
    const end = Math.floor(this.range.end());

    const max = this.layout.get('maxQuality');
    const yMax = this.layout.height();

    const y = d3.scaleLinear().domain([0, max]).range([0, yMax]);
    const x = this.slice.x();

    const qualityScores = this.qualityOption().get('visible') ? this.data.get('qualityScores') : [];
    const hoverBar = d3
      .select(this.el)
      .select('g')
      .select('g.quality-hover-bars')
      .selectAll('rect')
      .data(
        _.chain(qualityScores)
          .map((q, i) => [q, i])
          .filter((d, i) => d[0] !== 0 && start <= i && i < end)
          .value()
      );

    const {layout} = this;
    hoverBar
      .join('svg:rect')
      .classed('hoverBar', true)
      .each(function (d) {
        return $(this).tooltip({
          delay: {show: 2000, hide: 0},
          placement: 'top',
          container: 'body',
          trigger: 'manual',
          animate: false,
        });
      })
      .attr('x', (d) => x(d[1]))
      .attr('width', x(1))
      .attr('y', (d) => yMax - y(d[0]))
      .attr('height', (d) => y(d[0]))
      .attr('fill', d3.rgb(layout.get('qualityFillColor')).darker())
      .attr('fill-opacity', 0.0)
      .on('mouseenter', function () {
        d3.select(this).attr('fill-opacity', layout.get('qualityFillOpacity'));
        // FIXME: Why didn't trigger: hover, work? also fix in voteview.js
        clearTimeout($(this).data('showIntervalId'));
        return $(this).data(
          'showIntervalId',
          setTimeout(
            // eslint-disable-next-line no-restricted-syntax
            _.bind(function () {
              return $(this).tooltip('show');
            }, this),
            300
          )
        );
      })
      .on('mouseleave', function () {
        clearTimeout($(this).data('showIntervalId'));
        $(this).data('showIntervalId', null);
        $(this).tooltip('hide');
        return d3.select(this).attr('fill-opacity', 0.0);
      })
      .on(
        'click',
        // eslint-disable-next-line no-restricted-syntax
        _.bind(function (e, d) {
          this.model
            .get('sequence')
            .get('selection')
            .setEndpoints(d[1], d[1] + 1);
          return e.stopPropagation();
        }, this)
      )
      .each(function (d) {
        $(this).attr('data-original-title', `Quality: ${d[0]}`);
        return $(this).tooltip('fixTitle');
      });

    hoverBar.exit().each(function () {
      $(this).tooltip('destroy');
    });

    Perf.markEnd(this.performanceId);
  }

  update(trigger) {
    if (trigger == null) {
      trigger = true;
    }
    if (!this.shouldShow()) {
      return;
    }

    const start = this.slice.start();
    const end = this.slice.end();

    const id = (f) => f;
    const x = this.slice.x();
    let y = d3
      .scaleLinear()
      .domain([0, this.layout.get('maxQuality')])
      .range([this.layout.height(), 0]);
    const path = d3.select(this.el).select('g').select('g.quality-bars').select('path');
    const quality = !this.qualityOption().get('visible')
      ? []
      : _.chain(this.data.get('qualityScores').slice(start, end))
          .map((q, i) => {
            const j = i + start;
            return q
              ? [
                  [j, 0],
                  [j, q],
                  [j + 1, q],
                  [j + 1, 0],
                ]
              : null;
          })
          .flatten(true)
          .value();
    const qualityData = this._getDataString(quality, x, y);
    const root = d3
      .select(this.el)
      .select('g')
      .select('g.quality-bars')
      .selectAll('path')
      .data([qualityData]);
    const line = d3
      .line()
      .x((d) => x(d[0]))
      .y((d) => y(d[1]));
    root
      .join('svg:path')
      .attr('d', (d) => d)
      .attr('stroke', this.layout.get('qualityStrokeColor'))
      .attr('fill', this.layout.get('qualityFillColor'))
      .attr('fill-opacity', this.layout.get('qualityFillOpacity'))
      .attr('stroke-opacity', this.layout.get('qualityStrokeOpacity'));
    // .attr('shape-rendering', 'optimizeSpeed')

    const color = d3
      .select(this.el)
      .select('g')
      .select('g.color-data')
      .selectAll('path')
      .data(_.pairs(this.data.get('baseToColor')));

    const maxY = this.data.get('maxY');
    y = d3.scaleLinear().domain([0, maxY]).range([this.layout.height(), 0]).clamp(true);
    // eslint-disable-next-line no-restricted-syntax
    const realToGap = _.bind(function (pos) {
      return this.sequence.get('_sequence').realToGap(pos);
    }, this);
    // eslint-disable-next-line no-restricted-syntax
    const getData = _.bind(function (d) {
      return this._getDataString(this._getIndexToBases(d, start, end, x, y), id, id);
    }, this);

    color
      .join('svg:path')
      .attr('d', (d) => getData(d[1]))
      .attr(
        'stroke',
        // eslint-disable-next-line no-restricted-syntax
        _.bind(function (d) {
          return this.layout.get('colorMap')[d[0]];
        }, this)
      )
      .attr('stroke-width', this.layout.get('colorStrokeWidth'))
      .attr('fill', 'none');
    // .attr('shape-rendering', 'optimizeSpeed')

    this.drawHoverBoxes();
    if (trigger) {
      return this.trigger('redraw');
    }
  }

  setup() {
    super.setup();
    const root = d3.select(this.el).select('g');
    root.append('svg:g').attr('class', 'quality-bars');
    const hoverBars = root.append('svg:g').attr('class', 'quality-hover-bars');
    addTestAttrsToD3Selection(hoverBars, {component: 'TraceView', element: 'qualityHoverBars'});
    return root.append('svg:g').attr('class', 'color-data');
  }

  registerListeners() {
    super.registerListeners();
    // eslint-disable-next-line no-restricted-syntax
    this.listenTo(this.range, 'change:start change:end', debounce(_.bind(this.drawHoverBoxes, this), 500));
    this.listenTo(this.data, 'change:maxY', () => {
      this.update();
    });
    this.listenTo(this.qualityOption(), 'change:visible', () => {
      this.update();
    });
  }
}
TraceView.initClass();

export default TraceView;
